export default __webpack_public_path__ + "static/media/billing-model.16686476.png";